import "../components/ContactForm7";
import "../components/contact-component";

document.addEventListener( 'wpcf7mailsent', function( event ) {
  if (typeof fbq !== 'undefined') {
    fbq('track', 'Lead');
  }
}, false);
